import React, { useState, useContext } from "react";

import { AppContext } from "../../AppContext";

import DateUtil from "../../common/dateUtil";

import ErrorComp from "../common/ErrorComp";
import { HandleStatusCodeThenJson } from "../../common/FetchHelpers";

import PreTradeForm from "./PreTradeForm";
import PreTradePreviewComp from "./PreTradePreviewComp";

import PreTradeSurveyFormComp from "./survey/PreTradeSurveyFormComp";


import { fetchCall } from "../../common/FetchHelpers";

const PreTradeEditorComp = (props) => {
    
    const reqUrl = "api/trade-request/create";
    const [appContext, setAppContext] = useContext(AppContext);
    
    const secTypes = JSON.parse(appContext.appFeature.EMP_PRETRADE_REQUEST_SECURITY_TYPES);
 
    let submittedFor = '';
    
  const getDefaultSecurityType = () =>{
    
    for (var prop in secTypes) {
      if(secTypes[prop])
        return prop;
    }
    return "";
  }
   const defaultSecurityType = getDefaultSecurityType();

    const emptyPreTradeItem = {
        id: -1,
        securityType: defaultSecurityType,
        cusip: "",
        securitySymbol: "",
        securityDesc: "",
        quantity: "",
        accountNumber: "",
        finInstituteId: "",
        finInstitute: "",
        tradeAction: "",
        tradeDate: "",
        orderType: "",
        limitStop: "",
        timeForce: "",
        liquidationAmount: "",
        account: null,
        dollarAmount: "",

        businessName: "",
        businessDesc: "",
        ownershipShares: "",
        ownershipPercent: "",
        passiveInvolvement: "",
        clientInvolvement: "",
        businessKnowledgeSource: "",
        publicTradeEntity: "",
        businessCustody: "",
        capitalRaiseDesc: "",
        compensationMethod: "",
        custodiedInvestment: "",
        attachments: null
    };


    const [showEditor, setShowEditor] = useState(true);
    const [showPreview, setShowPreview] = useState(false);
    const [showError, setShowError] = useState(false);

    const [detailMode, setDetailMode] = useState("PREVIEW");

    const [formData, updateFormData] = useState(props.formData);



    const handleChange = (e) => {
        if(e.target.name === 'submittedFor') {
            updateFormData({...formData, [e.target.name]: e.target.value, submittedForLabel: e.target.label});
          } else if (e.target.name === "finInstituteId") {
            let finName = "";

            let fin = props.metadata.finInstitute.find((obj) => {
                return obj.id === e.target.value;
            });
            if (fin) {
                finName = fin.name;
            }
            updateFormData({
                ...formData,
                [e.target.name]: e.target.value,
                finInstitute: finName,
            });
        } else {
            const value = (e.target.files && e.target.files[0])?e.target.files[0]:e.target.value;
            updateFormData({...formData, [e.target.name]:value});
            console.log(formData);
        }
    };

    const handleDateChange = (date) => {
        updateFormData({
            ...formData,
            tradeDate: date
        });
    };

    const onUserSelected = (e)=>{
        submittedFor = e.target.value;
    };

    const handleAttachmentChange = (attachments) => {
        updateFormData({
            ...formData,
            attachments: attachments
        });
    };

    const handleAccountSelectionChanged = (acc) => {
        updateFormData({
            ...formData,
            account: acc,
            accountNumber: acc.accountNumber,
            finInstituteId: acc.brokerDealerId,
            finInstitute: acc.brokerDealerName
        });
    };

    const handleSaveClick = () => {
        setDetailConfig(defaultConfig);
        setShowEditor(false);
        setShowPreview(true);
    };

    const handleSubmit = () => {

        let tradeDate = DateUtil.toStrDate(formData.tradeDate);

        let jsonData = {
            ...formData,
            tradeDate: tradeDate,
            passiveInvolvement: formData.isPassiveInvestor === 'Yes' ? formData.passiveInvolvement : "",
            clientInvolvement: formData.isClientInvolve === "Yes" ? formData.clientInvolvement : "",
            publicTradeEntity: formData.isPublicBusiness === "Yes" ? formData.publicTradeEntity : "",
            businessCustody: formData.isBusinessCustody === "Yes" ? formData.businessCustody : "",
            capitalRaiseDesc: formData.isCapitalRaise === "Yes" ? formData.capitalRaiseDesc : "",
            isOwnershipBeneficial: formData.isOwnershipBeneficial === "Yes"
        };

        if(jsonData.submittedFor === null)
            delete jsonData.submittedFor;
        
        console.log(jsonData);

        const fData = new FormData();

        for ( var key in jsonData ) {
            if(key ==='attachment' && jsonData[key]){
                fData.append('file', jsonData[key]);    
            }
            let fieldVal = jsonData[key]??"";
            fData.append(key, fieldVal);
        }
        createPretradeRequest(fData, props.editorMode === "NEW");


    };

    const handleClosePreview = () => {

        setShowEditor(true);
        setShowPreview(false);
    };

    const handleAddAnother = () => {
        setDetailConfig(defaultConfig);
        updateFormData({...emptyPreTradeItem,template:props.formData.template});
        handleClosePreview();
    };


    const handleSubmitSurvey = (item) => {
        const fData = new FormData();
        fData.append("id", item.id);
        fData.append("templateStr", item.template.templateStr);
        fData.append("formData", JSON.stringify(item.formData));

        fData.append("securityType", item.formData.securityType);
        fData.append("securityDesc", item.formData.businessName);
        
        fData.append("businessName", item.formData.businessName);
        fData.append("businessDesc", item.formData.businessDescription);

        fData.append("dollarAmount", item.formData.piDollarAmount);
        fData.append("quantity", item.formData.piQuantity);
        fData.append("publicTradeEntity", item.formData.piIsPubliclyTraded);
        fData.append("businessKnowledgeSource", item.formData.piOpportunityReference);

        if(item.formData.piIsPassive === 'NO'){
            fData.append("passiveInvolvement", item.formData.piPassiveDesc);
        } else {
            fData.append("passiveInvolvement", item.formData.piIsPassive);
        }

        if(item.formData.piCustodian === 'Broker/Dealer'){
            fData.append("accountNumber", item.formData.piFinancialInstituteName);
            fData.append("finInstitute", item.formData.piFinancialInstituteName);
        }
        else if(item.formData.piCustodian === 'Other')
            fData.append("accountNumber", item.formData.piCustodianOther);
        else fData.append("accountNumber", item.formData.piCustodian);
        


        if(submittedFor)
          fData.append("submittedFor", submittedFor);
        
        if (item.changes && item.changes.length>0) {
          fData.append("changes", JSON.stringify(item.changes));
        }
        
        updateFormData(item);
        createPretradeRequest(fData, false);
      }


      const createPretradeRequest = (fData,reloadSummary)=>{
        const reqOptions = {
            method: "POST",
            body: fData
        };


        fetchCall(reqUrl, reqOptions)
            .then((result) => {
                if (reloadSummary) {
                    setAppContext({ ...appContext, reloadSummary: true });
                }
                setDetailConfig({
                    ...detailConfig,
                    detailMode: "POSTREVIEW",
                    title: "Request submitted",
                    status: {
                        state: "success",
                        message: "Request successfully submitted",
                    },
                    btnOk: {
                        ...detailConfig.btnOk,
                        label: "Add Another request",
                        handler: handleAddAnother
                    },
                    btnCancel: {
                        label: "Close",
                        handler: props.handleClose,
                    },
                });

            })
            .catch((err) => {
                console.log("Error, with message:", err.statusText);
                setShowEditor(false);
                setShowPreview(false);
                setShowError(true);
            }
            );
      }


    const defaultConfig = {
        editorMode: props.editorMode,
        detailMode: detailMode,
        title: "Review your request before submitting",
        status: {
            state: "",
            message: "",
        },
        btnOk: {
            label: "Submit",
            handler: handleSubmit,
        },
        btnCancel: {
            label: "Edit Before Submit",
            handler: handleClosePreview,
        },
    };
    const [detailConfig, setDetailConfig] = useState(defaultConfig);

    let formComp;
    const isTemplatedForm = () => {
        return props.formData.template != null && props.formData.template !== "";
    }

if(isTemplatedForm()){
    formComp = <PreTradeSurveyFormComp
    editorMode={props.editorMode} 
    data={formData}
    config={detailConfig}
    onUserSelected={onUserSelected}
    handleCancel={props.handleClose}
    handleSubmitSurvey={handleSubmitSurvey} />
} else {
    formComp = <PreTradeForm
    metadata={props.metadata}
    data={formData}
    handleChange={handleChange}
    handleDateChange={handleDateChange}
    handleAccountSelectionChanged={handleAccountSelectionChanged}
    handleSaveClick={handleSaveClick}
    handleCancel={props.handleClose}
    handleAttachmentChange={handleAttachmentChange}
/>
}

    return (
        <>
            {showPreview && (
                <PreTradePreviewComp
                    config={detailConfig}
                    data={formData}
                    btnOk={{label: detailConfig.btnOk.label, handler: handleSubmit }}
                    handleClose={props.handleClose}
                />
            )}
            {showEditor && (formComp)}

            {showError && <ErrorComp />}
        </>
    );
};

export default PreTradeEditorComp;
